import comp from "./WorksheetTextView";
export default comp;
